/**
 * Oeffentliche Datenschutzerklaerung (ohne Login erreichbar).
 * URL fuer Google OAuth Consent Screen & TikTok App Audit.
 */
const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-semibold">{title}</h2>
    <div className="text-sm leading-relaxed text-slate-600 space-y-2">{children}</div>
  </section>
);

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-8">
        <header className="space-y-2 border-b border-slate-200 pb-6">
          <p className="text-xs font-semibold tracking-widest text-[#2563EB] uppercase">InvictaFlow — InvictaX Group GmbH</p>
          <h1 className="text-3xl font-bold">Datenschutzerklärung</h1>
          <p className="text-sm text-slate-500">Stand: Juni 2026 · Gilt für die Anwendung InvictaFlow (app.invictaflow.ch)</p>
        </header>

        <Section title="1. Verantwortliche Stelle">
          <p>
            Verantwortlich für die Datenbearbeitung im Rahmen dieser Anwendung ist die InvictaX Group GmbH, Bahnhofstrasse 75, 8620 Wetzikon, Schweiz.
            Kontakt: <a href="mailto:info@strongfit.ch" className="text-[#2563EB] underline">info@strongfit.ch</a>
          </p>
        </Section>

        <Section title="2. Zweck der Anwendung">
          <p>
            InvictaFlow ist ein internes Marketing-Betriebssystem der InvictaX Group GmbH zur Verwaltung von
            Social-Media-Inhalten, Werbekampagnen, Website-Statistiken und Kundenanfragen (Leads) der
            angeschlossenen Unternehmen.
          </p>
        </Section>

        <Section title="3. Welche Daten wir bearbeiten">
          <p><strong>Kontaktanfragen (Lead-Formulare):</strong> Name, E-Mail, Telefon, Firma und Nachricht, die Sie freiwillig über unsere Anfrageformulare übermitteln — ausschliesslich zur Bearbeitung Ihrer Anfrage.</p>
          <p><strong>Website-Statistiken:</strong> Auf Websites der angeschlossenen Unternehmen erfassen wir anonymisierte Nutzungsdaten (aufgerufene Seiten, Herkunftsquelle, Gerätetyp) ohne Bildung von persönlichen Profilen.</p>
          <p><strong>Social-Media- und Werbekonten:</strong> Mit ausdrücklicher Autorisierung der Kontoinhaber verbinden wir Unternehmenskonten von Meta (Facebook/Instagram), TikTok, LinkedIn und Google (Ads), um Inhalte zu veröffentlichen und Kampagnen-Kennzahlen abzurufen. Zugriffs-Token werden verschlüsselt gespeichert.</p>
          <p><strong>Nutzerkonten:</strong> Für interne Mitarbeitende speichern wir Name, E-Mail und verschlüsselte Zugangsdaten.</p>
        </Section>

        <Section title="4. Google-Nutzerdaten (Google API Services)">
          <p>
            Die Nutzung von Daten aus Google-APIs (z.B. Google Ads) erfolgt gemäss der{" "}
            <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer" className="text-[#2563EB] underline">
              Google API Services User Data Policy
            </a>{" "}
            einschliesslich der Limited-Use-Anforderungen. Wir rufen ausschliesslich Kampagnen- und
            Conversion-Daten der verbundenen Werbekonten ab, geben diese nicht an Dritte weiter und
            verwenden sie nicht für Werbung ausserhalb der Anwendung.
          </p>
        </Section>

        <Section title="5. Weitergabe an Dritte">
          <p>
            Eine Weitergabe erfolgt nur an die von uns eingesetzten Dienstleister, soweit für den Betrieb
            erforderlich: Meta Platforms, TikTok, LinkedIn, Google (Veröffentlichung/Kampagnen), OpenAI und
            Google Gemini (KI-Texterstellung, ohne Übermittlung von Personendaten aus Leads) sowie Hosting-Anbieter.
            Es findet kein Verkauf von Daten statt.
          </p>
        </Section>

        <Section title="6. Speicherdauer & Sicherheit">
          <p>
            Daten werden nur so lange gespeichert, wie es für die genannten Zwecke erforderlich ist.
            Zugangsdaten und API-Schlüssel werden verschlüsselt abgelegt; der Zugriff ist auf berechtigte
            Administratoren beschränkt. Übertragungen erfolgen ausschliesslich über HTTPS.
          </p>
        </Section>

        <Section title="7. Ihre Rechte">
          <p>
            Sie haben nach dem Schweizer Datenschutzgesetz (DSG) und — soweit anwendbar — der DSGVO das Recht auf
            Auskunft, Berichtigung, Löschung und Einschränkung der Bearbeitung Ihrer Personendaten sowie auf
            Datenübertragbarkeit. Wenden Sie sich dazu an{" "}
            <a href="mailto:info@strongfit.ch" className="text-[#2563EB] underline">info@strongfit.ch</a>.
          </p>
        </Section>

        <Section title="8. Änderungen">
          <p>Wir können diese Datenschutzerklärung bei Bedarf anpassen. Es gilt die jeweils hier veröffentlichte Fassung.</p>
        </Section>

        <footer className="pt-6 border-t border-slate-200 text-xs text-slate-400">
          InvictaX Group GmbH · Bahnhofstrasse 75 · 8620 Wetzikon · InvictaFlow · <a href="/terms" className="underline">Nutzungsbedingungen</a>
        </footer>
      </div>
    </div>
  );
}
